import { Link, NavLink } from 'react-router-dom';

const linkCls = ({ isActive }: { isActive: boolean }) =>
    `hover:text-ptm-accent transition-colors ${isActive ? 'text-ptm-accent' : 'text-ptm-ink'}`;

export function Nav() {
    return (
        <header className="border-b border-slate-200 bg-white">
            <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
                <Link to="/" className="text-xl font-semibold tracking-tight no-underline">
                    Protomation<span className="text-ptm-accent">.</span>
                </Link>
                <nav className="flex items-center gap-6 text-sm font-medium">
                    <NavLink to="/login" className={linkCls}>Log in</NavLink>
                    <Link
                        to="/quote"
                        className="rounded-md bg-ptm-accent px-4 py-2 text-sm font-semibold text-white no-underline hover:bg-orange-600"
                    >
                        Request a Quote
                    </Link>
                </nav>
            </div>
        </header>
    );
}
